<button class="db-anniversary-offer__toggle" [ngClass]="{'active': isToggled}" (click)="toggleBanner()">
  <span>30% lifetime discount
    <!--<b><i class="db-icon db-icon-ds-timer mr2"></i>{{hoursLeft}}{{countDownUnit}}</b>-->
  </span>
</button>

<db-anniversary-offer-banner *ngIf="isToggled"
                             [hoursLeft]="hoursLeft"
                             [endDate]="endDate"
                             [startDate]="startDate"
                             [countDownUnit]="countDownUnit"
                             [isFreePlan]="user?.starterClient"
                             [countdown]="countDownMinutes"
                             (onClose)="toggleBanner()"
                             (onSendGAEvent)="sendGAEvent($event)"></db-anniversary-offer-banner>
